// extracted by mini-css-extract-plugin
export var avatarContainer = "_gd-0";
export var avatarTypingWave = "_gd-i";
export var gray = "_gd-f";
export var green = "_gd-c";
export var icon = "_gd-9";
export var image = "_gd-1";
export var lg = "_gd-6";
export var md = "_gd-5";
export var presenceDot = "_gd-b";
export var red = "_gd-d";
export var sm = "_gd-4";
export var status = "_gd-a";
export var typingDot = "_gd-h";
export var typingPill = "_gd-g";
export var xl = "_gd-7";
export var xs = "_gd-3";
export var xxl = "_gd-8";
export var xxs = "_gd-2";
export var yellow = "_gd-e";